import UI from '/javascripts/utils/UI'
import bus from '/javascripts/bus'
import Sketch from 'sketch-js'

const TWO_PI = Math.PI * 2
const SWEEP_SIZE = 2
const SWEEP_SPEED = 1.2
const SWEEP_ANGLE = 270
const TOTAL_RINGS = 5
const LINE_WIDTH = 1

UI({
  component: '.js-radar',
}, ({ component }) => {
  const state = { width: 0 }

  setComponentWidth()

  const DIAMETER = state.width
  const RADIUS = (DIAMETER / 2)

  const ctx = Sketch.create({
    container: component,
    fullscreen: false,
    width: DIAMETER,
    height: DIAMETER
  })

  const gradient = ctx.createLinearGradient(RADIUS, 0, 0, 0)

  let sweepAngle = SWEEP_ANGLE

  bus.on('windowResize', (event) => setComponentWidth())

  function setComponentWidth () {
    const componentWidth = component.getBoundingClientRect().width
    state.width = componentWidth
  }

  gradient.addColorStop(0, 'rgba(255, 255, 255, 0.7)')
  gradient.addColorStop(1, 'rgba(255, 255, 255, 1)')

  function renderRings () {
    var i
    for (i = 0; i < TOTAL_RINGS; i++) {
      ctx.beginPath()
      ctx.arc(RADIUS, RADIUS, ((RADIUS - (LINE_WIDTH / 2)) / TOTAL_RINGS) * (i + 1), 0, TWO_PI, false)
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.03)'
      ctx.lineWidth = LINE_WIDTH
      ctx.stroke()
    }
  }

  function renderSweep () {
    ctx.save()
    ctx.translate(RADIUS, RADIUS)
    ctx.rotate(dToR(sweepAngle))
    ctx.beginPath()
    ctx.moveTo(0, 0)
    ctx.arc(0, 0, RADIUS, dToR(-SWEEP_SIZE), dToR(SWEEP_SIZE), false)
    ctx.closePath()
    ctx.fillStyle = gradient
    ctx.fill()
    ctx.restore()
  }

  function dToR (degrees) {
    return degrees * (Math.PI / 180)
  }

  ctx.clear = function () {
    ctx.globalCompositeOperation = 'destination-out'
    ctx.fillStyle = 'hsla(0, 0%, 0%, 0.1)'
    ctx.fillRect(0, 0, DIAMETER, DIAMETER)
  }

  ctx.update = function () {
    sweepAngle += SWEEP_SPEED
  }

  ctx.draw = function () {
    ctx.globalCompositeOperation = 'lighter'
    renderRings()
    renderSweep()
  }
})
